export default __webpack_public_path__ + "static/media/RafinBassFishing.2ee15372.png";